// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ZaJrw","col":"styles_col__2NbCy","fulfillmentStatus":"styles_fulfillmentStatus__2h0i0","emailCol":"styles_emailCol__30OLZ"};